
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReviewVideo extends Vue {
  @Prop() videoId!: string;
}
